import { ShimmerThumbnail, ShimmerTitle } from 'react-shimmer-effects';
import styled, { css, keyframes } from 'styled-components';

import { ThemeProp } from '../../theme/Themes';

const backgroundProps = (props: ThemeProp & ShimmerProps) => {
  return `background: ${props.backgroundColor ? props.backgroundColor : props.theme.gradients.shimmer};
      background-size: ${props.verticalAnimation ? '100% 2000px' : '1000px 100%'};}`;
};

interface ShimmerProps {
  width?: string;
  height?: string;
  marginTop?: string;
  marginBottom?: string;
  marginRight?: string;
  borderRadius?: string;
  opacity?: string;
  disableFlex?: boolean;
  backgroundColor?: string;
  verticalAnimation?: boolean;
}

export const ShimmerImage = styled(ShimmerThumbnail)<ShimmerProps>`
  && {
    display: block;
    &.shimmer {
      ${(props: ThemeProp) => backgroundProps(props)}
    }
    &.shimmer-thumbnail {
      min-width: unset;
      margin-bottom: ${(props: ShimmerProps) => props.marginBottom || '0px'} !important;
      width: ${(props: ShimmerProps) => props.width || '100%'};
      height: ${(props: ShimmerProps) => props.height || '100%'};
    }
    border-radius: ${(props: ShimmerProps) => props.borderRadius || '0'};
  }
`;

const shimmer = keyframes`
 0% {
    background-position: 0 500px;
  }
  100% {
    background-position: 0 -500px;
  }
`;

export const ShimmerText = styled(ShimmerTitle).attrs(() => {
  return { line: 1 };
})<ShimmerProps>`
  && {
    ${(props) => props.$justifyFlexEnd && 'justify-content: flex-end;'};
    flex: ${(props: ShimmerProps) => (!props.disableFlex ? '1' : 'unset')};
    & .shimmer {
      ${(props: ShimmerProps) =>
        props.verticalAnimation &&
        css`
          animation: ${shimmer} 2.2s linear infinite forwards;
        `}
      ${(props: ThemeProp & ShimmerProps) => backgroundProps(props)}
      ${(props: ShimmerProps) => props.opacity && `opacity: ${props.opacity}`};
    }
    &.shimmer-title {
      margin-bottom: ${(props: ShimmerProps) => props.marginBottom || '0px'} !important;
      margin-right: ${(props: ShimmerProps) => props.marginRight || '0px'} !important;
    }
    & .shimmer-title-line {
      margin-top: ${(props: ShimmerProps) => props.marginTop || '0'} !important;
      height: ${(props: ShimmerProps) => props.height || '1rem'};
      border-radius: ${(props: ShimmerProps) => props.borderRadius || '0'};
      &:first-child {
        width: ${(props: ShimmerProps) => props.width || '100%'} !important;
      }
    }
  }
`;
